'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getConnector = undefined;
exports.setLogLevel = setLogLevel;
exports.setProvider = setProvider;

var _diffusionConnector = require('./diffusionConnector');

var _diffusionConnector2 = _interopRequireDefault(_diffusionConnector);

var _cachedValue = require('../utils/cachedValue');

var _providers = require('../providers');

var _logger = require('../utils/logger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setLogLevel(logLevel) {
    (0, _providers.log)(logLevel);
    (0, _logger.setLevel)(logLevel);
}

var getConnector = exports.getConnector = (0, _cachedValue.singleValue)(function () {
    var connectorInstance = (0, _diffusionConnector2.default)((0, _providers.getProvider)());
    window.addEventListener('beforeunload', connectorInstance.closeSession);
    return connectorInstance;
}).getValue;

function setProvider(provider) {
    getConnector().setProvider(provider);
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/connector/index.js
// module id = 361
// module chunks = 1